import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Trans } from 'react-i18next'

import AccountSegmentSelector from './AccountSegmentSelector'
import PrivacyTermsFooter from './PrivacyTermsFooter'

import classes from './SignUpSegmentSelector.module.scss'

const SignUpSegmentSelector = ({ onIndividualClick, onFamilyClick }) => (
  <>
    <h5 className={classNames(classes.titleText, 'mt-4')}>
      <Trans i18nKey='auth.signUpSegmentSelector.heading'>
        Let&apos;s get to know you...
        <br />
        Which describes you best?
      </Trans>
    </h5>

    <AccountSegmentSelector
      onIndividualClick={onIndividualClick}
      onFamilyClick={onFamilyClick}
      wrapperClassName='mb-3 w-100'
    />

    <PrivacyTermsFooter />
  </>
)

SignUpSegmentSelector.propTypes = {
  onIndividualClick: PropTypes.func.isRequired,
  onFamilyClick: PropTypes.func.isRequired,
}

export default SignUpSegmentSelector
